module.exports = __webpack_public_path__ + "static/media/logo115.d98fce62.png";